import * as React from "react";

const SvgTrapezoidL2 = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="199"
    fill="none"
    viewBox="0 0 364 199"
  >
    
    <path
      fill="#D7EAFF"
      stroke={rackColor}
      strokeWidth="15"
      d="M5 5v189h153.333v-68.657H359V5z"
    ></path>
     <path
      d="M0 0v202h165.333v-68.657H364V0z"
      fill="none"
      stroke="black"
      strokeWidth="1"
    />
  </svg>
);

export default SvgTrapezoidL2;
